import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['unitId']

  connect() {
    // converts select2 events into native events
    $('#lease_unit_id').on('select2:select', function () {
      let event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    });

    this.selectUnit()
  }

  selectUnit() {
    let unitId = this.unitIdTarget.value
    let communityId = $(this.unitIdTarget).data('communityId')
    let leaseId = $(this.unitIdTarget).data('leaseId')
    let leaseResidents = document.getElementById('lease_lease_residents_input')

    if (unitId) {
      $.get({
        url: `/admin/communities/${communityId}/leases/lease_residents`,
        data: {
          id: leaseId,
          unit_id: unitId
        },
        success: (results) => {
          $(leaseResidents).replaceWith(results)
        }
      })
    }
  }
}